export default __webpack_public_path__ + "static/dairy-free-health-2-desktop-b739ba9bf8d96ac5c45a97b764495c87.png";